import { types } from './types';


const INITIAL_STATE = {
  grids: {
    'predicted': { rows: [], total: 0 },
    'new-orders': { rows: [], total: 0 },
    'estimated': { rows: [], total: 0 },
    'picking': { rows: [], total: 0 },
    'ready-to-go': { rows: [], total: 0 },
    'shipping': { rows: [], total: 0 },
    'returning-to-storage': { rows: [], total: 0 },
    'history': { rows: [], total: 0 },
    'all-orders': { rows: [], total: 0 },
  },
  order: {},
  dashboard: { loaded: false },
  logs: { logs: [], loaded: false },
  totals: [],
  reasons: [],
  statusHistory: [],
  motivosInsucesso: [],
  motivosRecusa: [],
  motivosCancelarRetirada: [],
  setModalClosed: false,
  page: 0,
  filters: {
    minDias: 0,
  },
  loaded: false,
  limit:20,
  reRender:false,
  devolution: true,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ORDERS:
      return {
        ...state, ...action.payload, grids: {
          ...state.grids,
          ...action.payload.grids,
        }
      };
    case types.GET_ORDER:
      return { ...state, order: action.payload, loaded: true };
    case types.ADD_ORDERS:
      return {
        ...state,
        grid: {
          rows: [action.payload, ...state.grid.rows],
          total: state.grid.total + 1,
        },
      };
    case types.UPDATE_ORDER:
      return { ...state, ...action.payload };
    case types.GET_DASHBOARD:
      return { ...state, dashboard: { ...action.payload, loaded: true } };
    case types.GET_ORDER_LOGS:
      return { ...state, logs: { loaded: true, ...action.payload } };
    case types.GET_COUNTS:
      return { ...state, ...action.payload };
    case types.GET_REASONS:
      return { ...state, ...action.payload };
    case types.GET_ORDER_STATUS_HISTORY:
      return { ...state, ...action.payload };
    case types.SET_FILTER:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case types.SET_LIMIT:
      return { ...state, limit: action.payload };
    case types.SET_RENDER:
      return { ...state, reRender: action.payload };
    case types.SET_DEVOLUTION:
      return { ...state, devolution: action.payload };
    case types.GET_MOTIVOS_INSUCESSO:
      return { ...state, motivosInsucesso: action.payload };
    case types.GET_MOTIVOS_RECUSA:
      return { ...state, motivosRecusa: action.payload };
    case types.GET_MOTIVOS_CANCELAR_RETIRADA:
      return { ...state, motivosCancelarRetirada: action.payload };
    case types.SET_MODAL_CLOSED:
      return { ...state, setModalClosed: action.payload };
    case types.UPDATE_EVENT_IMPRIMIR_NOTA_FISCAL:
      return {
        ...state,
        order: {
          ...state.order,
          events: state.order.events.map(event =>
            event.tipo === 'IMPRIMIR_NOTA_FISCAL'
              ? { ...event, status: 'DONE' }
              : event
          ),
        },
      };
    default:
      return state;
  }
}
